export const saleAr = {
  "Numero": "الرقم",
  "Client": "الزبون",
  "Total": "المجموع الإجمالي",

  "Prix": "السعر",
  "Prix de vente": "ثمن البيع",
  "Quantité": "الكمية",
  "Donner le prix de vente": "إعط سعر البيع",
  "Donner la quantité": "أعط الكمية",
  "Choisir un client": "اختر الزبون",
  "Nom du produit": "إسم المنتج",
  "Montant": "المبلغ",
  "Montant que voulez vous payer": "المبلغ الذي تريد دفعه",
  
  "Produit": "المنتج",
  "Prix.Unitaire * Quantite": "سعر الوحدة * الكمية",

  "Chercher un bon de vente": "ابحث عن فاتورة المبيعات",

  "Chercher un service": "ابحث عن فاتورة تقدير",

  "Description": "الوصف",  

  "Chercher une sevice": "ابحث عن خدمة",
  "Services": "الخدمات",
  "Service": "خدمة",
  
  "Capital Social": "رأس المال",
  "Benefices": "الفوائد",
  "Pertes": "الخسائر",

}
